var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_9750",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 63,
    height: 63
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_9750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8687 57.75L30.7125 46.5938L34.3875 42.9188L41.8687 50.4L56.7 35.5688L60.375 39.2437L41.8687 57.75ZM31.5 28.875L52.5 15.75H10.5L31.5 28.875ZM31.5 34.125L10.5 21V47.25H24.0188L29.2688 52.5H10.5C9.05625 52.5 7.82031 51.9859 6.79219 50.9578C5.76406 49.9297 5.25 48.6938 5.25 47.25V15.75C5.25 14.3062 5.76406 13.0703 6.79219 12.0422C7.82031 11.0141 9.05625 10.5 10.5 10.5H52.5C53.9438 10.5 55.1797 11.0141 56.2078 12.0422C57.2359 13.0703 57.75 14.3062 57.75 15.75V27.1687L52.5 32.4188V21L31.5 34.125Z",
    fill: "#E9F8EA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailTick);
export default __webpack_public_path__ + "static/media/email-tick.ea37ad6b3ba0bc65f6e2156ef68be439.svg";
export { ForwardRef as ReactComponent };